import inView from 'in-view';

const inViewhelpers = () => {
  inView('.js-in-view')
    .on('enter', (el) => {
      el.classList.remove('is-leaving-view');
      el.classList.add('is-in-view');
    })
    .on('exit', (el) => {
      if (!el.classList.contains('in-view--dont-remove-on-exit')) {
        el.classList.remove('is-in-view');
      }
      el.classList.add('is-leaving-view');
    });
};

export default inViewhelpers;
